export default __webpack_public_path__ + "static/media/tiktok.9a73d466.svg";